const creds = {
   //backendUrl: '/api/', //Default API call end point.
	backendUrl: "https://smt.ebslab.in/api/", // Local development API end point.
  //backendUrl: "http://127.0.0.1:5000/api/", // Local development API end point.
 };
 export const url = creds.backendUrl;
 export default creds;
